export default function debounce(fn, delay = 400) {
  let timer = null;
  const debounced = function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
  debounced.cancel = function () {
    clearTimeout(timer);
  };
  return debounced;
}
